import { formatFiles } from "slices/collections/actions";

import { resolveFlowFiles } from "../pipeline";

const noFields = () => ({});

// Shared behaviour for every queue-backed target (FOLDER / OPPORTUNITY /
// CONTRACT / PROPOSAL / MISC_ANALYSIS). They differ only by `getFields`, which
// injects the entity metadata carried alongside each uploaded chunk.
export const createFlowStrategy = (config) => ({
  uploadUrl: config.uploadUrl,
  usesFlow: true,

  prepareFiles: ({ selectedFiles }) => selectedFiles,
  buildBaseInfo: () => ({}),
  getFields: config.getFields ?? noFields,
  beforeInitialize: async () => {},

  resolveInitResponse: ({ data, files }) => {
    const responseFiles = formatFiles(data.documents.files);
    return resolveFlowFiles({
      data,
      responseFiles,
      files,
      isCollectionsTarget: false,
    });
  },
});
